module.exports = "<div class=\"confirmationDialog onesite-base\" ng-class=\"'confirmationDialog--' + confirmationDialog.classes\" ng-show=\"confirmationDialog.showDialog\">\r\n    <div class=\"confirmationDialog-message\">\r\n        {{confirmationDialog.message}}\r\n    </div>\r\n    <button class=\"button button--primary\" ng-click=\"continue()\">Continue</button>\r\n    <button class=\"button\" ng-click=\"cancel()\">Cancel</button>\r\n</div>\r\n<div class=\"confirmationDialog-mask\" ng-show=\"confirmationDialog.showDialog\"></div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/confirmation-dialog/confirmation-dialog-template.html
 ** module id = 843
 ** module chunks = 2
 **/